module.exports = __webpack_public_path__ + "img/help_dataset_marker_small.96d190e2.png";